import gql from 'graphql-tag';

const updateFlatRateOfferBatchMutation = gql`
  mutation updateFlatRateOfferBatch($input: UpdateFlatRateOfferBatchInput!) {
    updateFlatRateOfferBatch(input: $input) {
      success
      errors
    }
  }
`;

export default updateFlatRateOfferBatchMutation;
